import "./module/header"
import "./module/swiper"
import "./module/onclicks"
import "./module/acc"

window.addEventListener("load", () => {
    let nowWidth = window.innerWidth >= 1024

    window.addEventListener("resize", () => {
        if (nowWidth != window.innerWidth >= 1024) {
            window.location.reload();
        }
    })
})